import { RouteConfig } from 'vue-router';
// import MswFsProductManagement from './product-management.vue';
import MswMyFlexspend from './my-flexspend.vue';
import FlexspendOld from './flexspend-old.vue';

export const flexspendPage: RouteConfig = {
  path: 'flexspend',
  component: FlexspendOld,
};

export const myFlexspendPage: RouteConfig = {
  path: 'myflexspend',
  component: MswMyFlexspend,
};

// export function getDefaultParams() {
//   return {};
// }
